"use client";

import { useTranslations } from "next-intl";
import { Title } from "@/components/ui/title";
import { Paragraph } from "@/components/ui/paragraph";
import { useAbout } from "@/context/about";
import AboutContent from './AboutContent.client';
import { cn } from "@/lib/utils";

type AboutProps = {
  preRenderedContent: string;
};

function About({ preRenderedContent }: AboutProps) {
  const { isOpen } = useAbout();
  const t = useTranslations('About');

  return (
    <section 
      id="about" 
      className={cn(
        "border-bottom-default", 
        // Using CSS visibility instead of display for SEO
        // 'visible' makes content visible to users
        // 'invisible' keeps content in DOM for search engines but hidden from users
        isOpen ? "visible" : "invisible h-0 overflow-hidden"
      )}
      // Do not use aria-hidden as it may affect screen readers
      data-seo="true"
    >
      <div className="container py-10 border-side-default">
        <Title>{t('title')}</Title>
        <Paragraph className="mt-2 mb-6">
          {t('description')}
        </Paragraph>
        <AboutContent content={preRenderedContent} />
      </div>
    </section>
  );
}

export default About;